import { createRequest, RequestConfig } from 'app/common/api';

import { TReportTemplate } from '../core/report';

const config: RequestConfig = {
  method: 'get',
  url: '/ws/api/get_report_template_file',
};

export const getReportTemplateFileRequest = (
  body: Pick<TReportTemplate, 'id'>
) =>
  createRequest({
    url: config.url,
    method: config.method,
    query: { id: String(body.id) },
  });
